// @mui material components
import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Presentation page sections
import InformationHome from "pages/Servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale/sections/sections/HeroSection";
import ArticleContent from "pages/Servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale/sections/sections/ArticleContent";

function CuratenieFabriciDepoziteHale() {
    return (
        <>
            <Helmet>
                <title>Curățenie Industrială pt. Fabrici, Depozite și Hale | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Curățenie industrială în hale, fabrici și depozite din București și Ilfov, adaptată turelor de producție. Utilaje profesionale. Cere o ofertă."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/curatenie-fabrici-depozite-hale/"
                />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                    {
                    "@type": "Question",
                    "name": "Lucrați și în afara Sectorului 4?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Da. Sediul nostru este în Sectorul 4, dar lucrăm în toate sectoarele Bucureștiului și în Ilfov, inclusiv în Voluntari, Pantelimon, Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și Otopeni. Deplasarea pentru evaluare este gratuită."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Intervenția echipei de curățenie va opri fluxul de producție?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nu, deoarece intervențiile noastre sunt planificate strategic astfel încât procesele dumneavoastră operaționale să se desfășoare fără blocaje sau timpi morți, asigurând continuitatea activității fără întreruperi. Putem lucra în afara orelor de program sau în weekend pentru a evita suprapunerile."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Cum garantați siguranța utilajelor și a instalațiilor din hală?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Lucrările sunt realizate cu respectarea strictă a normelor de siguranță și igienă, conform procedurilor specifice mediilor industriale, contribuind astfel la menținerea unui spațiu de lucru sigur și organizat. Operatorii noștri sunt instruiți să protejeze componentele electronice și mecanice sensibile."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Personalul dumneavoastră este pregătit pentru riscurile din mediul industrial?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Echipele noastre sunt formate exclusiv din personal instruit pentru medii industriale, fiind pregătite să lucreze eficient în spații de mari dimensiuni, în proximitatea utilajelor și în zonele cu trafic intens. Fiecare membru al echipei are instructajul de protecție a muncii efectuat."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Ce fel de dotări folosiți pentru a asigura curățenia în spații extinse?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Utilizăm tehnologie și echipamente profesionale de ultimă generație, special adaptate pentru curățenia industrială, care ne permit să asigurăm o eficiență sporită și rezultate constante pe suprafețe mari. Folosim mașini automate de spălat și aspiratoare industriale de mare capacitate."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Serviciile pot fi personalizate în funcție de programul fabricii noastre?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Oferim flexibilitate totală și adaptare la cerințele fiecărui client, astfel încât serviciile să fie ajustate specificului locației dumneavoastră, indiferent dacă aveți nevoie de întreținere zilnică sau de intervenții speciale. Graficul de lucru se stabilește de comun acord pentru a nu perturba logistica internă."
                    }
                    }
                    ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "Service",
                      "name": "Curățenie hale, fabrici și depozite",
                      "serviceType": "Curățenie industrială",
                      "url": "https://doral-cleaning.ro/curatenie-fabrici-depozite-hale/",
                      "provider": { "@id": "https://doral-cleaning.ro/#business" },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
            </Card>
        </>
    );
}

export default CuratenieFabriciDepoziteHale;
